/* eslint-disable react/no-danger */
import { useTranslation } from "next-i18next";
import Head from "next/head";
import withErrorHandler from "../../../component/design-system/withErrorHandler";
import BreadcrumbsMetaHead from "../../../component/meta-header/BreadcrumbsMetaHead";
import { getThumbImagePath } from "../../../util/helper/getThumbImagePath";

function TiresBySizeMetaHead(props: any) {
  const {
    size, products,
  } = props;
  const { t } = useTranslation("category");
  const bannerImageUrl = "https://partsavatar.ca/banners/tires.jpg";
  const keywords = [`Tires for ${size}`, size.replace("-", "/")];
  const description = t("tire_by_size_description");
  const title = `Tires ${size} - PartsAvatar.ca`;

  const meta = {
    title,
    image: bannerImageUrl,
    description,
    meta: {
      robots: "all",
    },
    keywords,
  };

  const itemListElement = products.map((product: any, position: any) => {
    const { canonicalUrl, description: pDesc, thumbnail } = product;
    return {
      "@type": "ListItem",
      position,
      url: `https://partsavatar.ca${canonicalUrl}`,
      name: pDesc,
      description: pDesc,
      image: getThumbImagePath(thumbnail),
    };
  });
  const microdata = {
    "@context": "http://schema.org/",
    "@type": "CollectionPage",
    mainEntity: {
      "@type": "ItemList",
      itemListElement,
      numberOfItems: products.length,
    },
  };
  const url = `https://partsavatar.ca/tires/${size}`;
  return (
    <>

      <Head>

        <title>{meta.title}</title>

        <meta name="description" content={meta.description} />

        <meta name="keywords" content={meta.keywords} />

        <meta name="robots" content={meta.meta.robots} />

        <link rel="canonical" href={url} />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(microdata) }}
        />

        <meta property="og:title" content={meta.title} />

        <meta property="og:description" content={meta.description} />

        <meta property="og:type" content="product.group" />

        <meta property="og:url" content={url} />

        <meta property="og:site_name" content="PartsAvatar.ca" />

        <meta property="og:image" content={meta.image} />

        <meta name="twitter:card" content="summary_large_image" />

        <meta name="twitter:title" content={meta.title} />

        <meta name="twitter:description" content={meta.description} />

        <meta name="twitter:image" content={meta.image} />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "http://schema.org",
              "@type": "WebPage",
              primaryImageOfPage: {
                "@type": "ImageObject",
                url: bannerImageUrl,
              },
            }),
          }}
        />

      </Head>

      <BreadcrumbsMetaHead
        breadCrumbList={[
          { title: "Wheels and Tires", url: "/wheels-tires" },
        ]}
      />
    </>
  );
}

export default withErrorHandler(TiresBySizeMetaHead);
